/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import type {DataGridPremiumComponents} from '@mui/x-data-grid-premium/themeAugmentation';
import type {Theme} from '../types';

export const MuiDataGrid = {
  styleOverrides: {
    root: {
      color: 'var(--mui-palette-text-primary)',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    filterIcon: {
      color: 'var(--mui-palette-primary-main)',
    },
    columnHeader: {
      '& .MuiDataGrid-iconButtonContainer': {},
    },
    toolbarContainer: {
      padding: 7,
      borderBottom: '1px solid var(--mui-palette-divider)',
      '& .MuiButton-root, & .MuiIconButton-root': {
        color: 'var(--mui-palette-text-secondary)',
      },
    },
    panel: {
      '& .MuiButton-root.MuiButton-textPrimary': {
        color: 'var(--mui-palette-text-primary)',
      },
      marginTop: '14px !important',
    },
    filterFormLogicOperatorInput: {
      display: 'none !important',
    },
  },
  defaultProps: {
    cellSelection: false,
    sx: {
      '& .MuiDataGrid-row:hover:not([data-id^="auto-generated"])': {
        cursor: 'pointer',
      },
      '& .MuiDataGrid-cell:focus': {
        outline: 'none',
      },
    },
  },
} satisfies DataGridPremiumComponents<Theme>['MuiDataGrid'];
